import { axiosInstance } from './axios-instance';
import * as endpoints from "../constants/api-constants";

class MagazineService {
    static postPDF(payload, config) {
        return axiosInstance.post(endpoints.postContent, payload, config).then(resp => resp.data)
    }
    static postText(payload, config) {
        return axiosInstance.post(endpoints.postContentText, payload, config).then(resp => resp.data)
    }
    static getComments(payload, config) {
        return axiosInstance.get(endpoints.getCommments + payload, config).then(resp => resp.data)
    }
    static setComments(payload, config) {
        return axiosInstance.post(endpoints.setCommments, payload, config).then(resp => resp.data)
    }
    static setCommentsReport(payload, config) {
        return axiosInstance.post(endpoints.setCommmentsReport, payload, config).then(resp => resp.data)
    }
    static postLikeAuth(payload, config) {
        return axiosInstance.post(endpoints.setLikes, payload, config).then(resp => resp.data)
    }
    static postLikeAnom(payload) {
        return axiosInstance.post(endpoints.setLikes, payload).then(resp => resp.data)
    }
    static getLikeById(id, countryId) {
        return axiosInstance.get(endpoints.getLikeById + '?contentId=' + id + '&country=' + countryId).then(resp => resp.data)
    }
    static getLikesArticles(country, config) {
        return axiosInstance.get(endpoints.getLikesArticles + '?country=' + country, config).then(resp => resp.data)
    }
    static saveArticle(config, payload) {
        return axiosInstance.put(endpoints.saveArticle +
            '?cmsId=' + payload.cmsId +
            '&state=' + payload.state
            , {}, config).then(resp => resp.data)
    }
    static getSavedArticles(config) {
        return axiosInstance.get(endpoints.saveArticle, config).then(resp => resp.data)
    }

}

export default MagazineService;